var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger-v4';
import { Expose } from 'class-transformer';
import { IsNotEmpty, IsString, ValidateIf } from 'class-validator';
import { CampaignStateEnum, CohortConfigParamContextEnum, CohortFeatureParamTypeEnum } from '../../campaign/interface';
import { TemplateExposeGroup } from '../interface';
export class ReadTemplateCohortConfigParamDto {
}
__decorate([
    ApiProperty({ example: '9eaa1d82-0b48-452e-baec-a00361937d67', type: () => String }),
    Expose({ groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG] }),
    __metadata("design:type", String)
], ReadTemplateCohortConfigParamDto.prototype, "featureId", void 0);
__decorate([
    ApiProperty({ example: 'lastOrderDate', type: () => String }),
    Expose({ groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG] }),
    __metadata("design:type", String)
], ReadTemplateCohortConfigParamDto.prototype, "placeholder", void 0);
__decorate([
    ApiProperty({ type: () => String, enum: Object.values(CohortFeatureParamTypeEnum) }),
    Expose({ groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG] }),
    __metadata("design:type", String)
], ReadTemplateCohortConfigParamDto.prototype, "type", void 0);
__decorate([
    ApiPropertyOptional({
        oneOf: [{ type: 'string' }, { type: 'number' }, { type: 'array', items: { oneOf: [{ type: 'string' }, { type: 'number' }] } }],
        example: 30,
    }),
    Expose({ groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG] }),
    __metadata("design:type", Object)
], ReadTemplateCohortConfigParamDto.prototype, "value", void 0);
__decorate([
    ApiProperty({ description: 'If cohort config param is editable', example: true, type: () => Boolean }),
    Expose({
        groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG],
    }),
    __metadata("design:type", Boolean)
], ReadTemplateCohortConfigParamDto.prototype, "editable", void 0);
__decorate([
    ApiProperty({ description: 'If cohort config param is required', example: true, type: () => Boolean }),
    Expose({
        groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG],
    }),
    __metadata("design:type", Boolean)
], ReadTemplateCohortConfigParamDto.prototype, "required", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Config param context', enum: CampaignStateEnum }),
    Expose({ groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG] }),
    __metadata("design:type", String)
], ReadTemplateCohortConfigParamDto.prototype, "context", void 0);
__decorate([
    ApiPropertyOptional({ example: 'Last order date', type: () => String }),
    Expose({ groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG] }),
    ValidateIf((param) => param.editable, {
        groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG],
    }),
    IsNotEmpty({ groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG] }),
    IsString({ groups: [TemplateExposeGroup.MODEL, TemplateExposeGroup.READ, TemplateExposeGroup.CONFIG] }),
    __metadata("design:type", String)
], ReadTemplateCohortConfigParamDto.prototype, "label", void 0);
//# sourceMappingURL=ReadTemplateCohortConfigParamDto.js.map